var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isIndexOf)?[_c('router-view',{style:(_vm.grayscaleStyle)})]:_c('div',{staticClass:"closeApp"},[_vm._v("出错啦!404")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }